//  This is a generated file, do not edit it directly
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgCheckedRadio } from '../icons/CheckedRadio';

export function CheckedRadioIcon(
  props: Omit<SvgIconProps, 'component' | 'children'>,
): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgCheckedRadio} data-qa="CheckedRadioIcon">
      <svg />
    </SvgIcon>
  );
}
